var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 9L6 4V8H10V10H6V14L0 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.1276 15.4777L17 14V6C17 4.89545 16.1045 4 15 4C13.8955 4 13 4.89545 13 6V20H12V17H11C9.89545 17 9 17.8954 9 19V21.8953C9 23.2578 9.46368 24.5797 10.3148 25.6436L13 29H26L27.5561 18.8855C27.8032 17.2794 26.7265 15.7684 25.1276 15.4777Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollHorizontal);
export default __webpack_public_path__ + "static/media/scroll-horizontal.262b0867905d023fa0597df6eda9ae41.svg";
export { ForwardRef as ReactComponent };